module.exports = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjYiIHZpZXdCb3g9IjAgMCAyNCAyNiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIxLjYgMi4zNjM2NEgyMC40VjBIMThWMi4zNjM2NEg2VjBIMy42VjIuMzYzNjRIMi40QzEuMDggMi4zNjM2NCAwIDMuNDI3MjcgMCA0LjcyNzI3VjIzLjYzNjRDMCAyNC45MzY0IDEuMDggMjYgMi40IDI2SDIxLjZDMjIuOTIgMjYgMjQgMjQuOTM2NCAyNCAyMy42MzY0VjQuNzI3MjdDMjQgMy40MjcyNyAyMi45MiAyLjM2MzY0IDIxLjYgMi4zNjM2NFpNMjEuNiAyMy42MzY0SDIuNFY4LjI3MjczSDIxLjZWMjMuNjM2NFoiIGZpbGw9IiMxREI5QjkiLz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/common/calendar.svg
// module id = nTXe
// module chunks = 7